export default __webpack_public_path__ + "41695e3.png";